module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "content-t",
    attrs: {
      "id": "calibre_toc_1"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("Your"), _c('br', {
    staticClass: "calibre3"
  })]), _vm._v("Next"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("Level"), _c('br', {
    staticClass: "calibre1"
  }), _c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("Life")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph1"
  }, [_vm._v("7 Rules of Power, Confidence, and "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Opportunity for Black Women in America")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph1"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph2"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("KAREN ARRINGTON "), _c('br', {
    staticClass: "calibre1"
  })]), _c('span', {
    staticClass: "char-style-override3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph3"
  }), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "char-style-override4"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "5110.png",
      "src": "OEBPS/image/5110.png"
    }
  })]), _c('br', {
    staticClass: "calibre3"
  })]), _c('span', {
    staticClass: "Italics"
  }, [_vm._v("Mango Publishing"), _c('br', {
    staticClass: "calibre3"
  })]), _c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("Coral Gables")])]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d7d4bf1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/YourNextLevelLife_split_001.vue
// module id = 60
// module chunks = 0